module.exports = __webpack_public_path__ + "static/img/2_1_6.bff865d1.jpg";